package one.healthium.domain.user

interface UserEvents {
    suspend fun onWaterIntakeAdded(taskId: String?)
    suspend fun onWeightUpdated(taskId: String?)
    suspend fun onFoodAdded(taskId: String?)
    suspend fun onSymptomsAdded(taskId: String?)
    suspend fun onHealthLogAdded(taskId: String?)
}

sealed class UserEvent {
    data class WaterIntakeAdded(val taskId: String?) : UserEvent()
    data class WeightUpdated(val taskId: String?) : UserEvent()
    data class FoodAdded(val taskId: String?) : UserEvent()
    data class SymptomsAdded(val taskId: String?) : UserEvent()
    data class HealthLogAdded(val taskId: String?) : UserEvent()
}